import React from 'react';
import { useEditorContext } from '../../../../components/Editor/Context';
import { isTouch } from '../../../../components/utils/browser';
import BlockBubbleMenu from '../../../../components/menus/BlockBubbleMenu';
import Delete from '../buttons/Delete';
import { getExtensionOptions, shouldBlockMenuBeOpen } from '../../../../components/utils/tiptap';
import Alignment from '../buttons/Alignment';
import Edit from '../buttons/Edit';
import cn from 'classnames';
const MenuButtons = ({ editor, forMobile = false })=>{
    const options = getExtensionOptions(editor, 'da-video');
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(!forMobile && 'ds-surface-tertiary'),
        style: {
            maxWidth: '100vw',
            display: 'flex',
            flexWrap: 'wrap'
        }
    }, options.canAlign && /*#__PURE__*/ React.createElement(Alignment, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Edit, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Delete, {
        editor: editor
    }));
};
const DaVideoBubbleMenu = ({ scrollContainerRef })=>{
    const editor = useEditorContext();
    if (!editor) {
        return null;
    }
    if (!(editor === null || editor === void 0 ? void 0 : editor.isEditable) || isTouch()) {
        return null;
    }
    const open = shouldBlockMenuBeOpen(editor, 'da-video');
    let buttonCount = 3;
    const options = getExtensionOptions(editor, 'da-video');
    if (!options.canAlign) {
        buttonCount--;
    }
    return /*#__PURE__*/ React.createElement(BlockBubbleMenu, {
        scrollContainerRef: scrollContainerRef,
        menuHeight: 38,
        menuWidth: 40 * buttonCount,
        editor: editor,
        open: open,
        childSelector: ".main-video"
    }, /*#__PURE__*/ React.createElement(MenuButtons, {
        editor: editor
    }));
};
DaVideoBubbleMenu.displayName = 'DaVideoBubbleMenu';
export default DaVideoBubbleMenu;
export { MenuButtons };

//# sourceMappingURL=DaVideoBubbleMenu.js.map